var site = site || {};

(function($) {
  "use strict";
  Drupal.behaviors.bfeed_fb = {
    attach: function(context, settings) {

      var $socialBlock = $('#social-content--facebook');

      site.bf_massrel.massrel_render(
        $socialBlock.data('massrel-feed'), // feed id
        $socialBlock, // actual element
        tweakData // mess with data returned from massrel
      );

      // Custom clean our data if need be
      function tweakData(data) {
//        var replace = /_s/gi;
        _.map(data, function(post) {
		  // Type of device
			post.type = 'photos';
			if($('body').hasClass('device-pc')){
			post.type = 'posts';};
          // time ago
          post.el_ago = $.timeago(post.created_time);
          // update image
//          post.picture = post.picture.replace(replace, '_n'); // use provided picture
		  
          post.picture = "//graph.facebook.com/" + post.object_id + "/picture?type=normal"; // call out to graph api
          return post;
        });

        return {mass_rel: data};
      }

    }
  };
})(jQuery);
